<template>
	<div class="content">
		<van-nav-bar title="游玩攻略" left-text="返回" left-arrow @click-left="onClickLeft" />
		<van-divider :style="{ color: '#1989fa', borderColor: '#1989fa', padding: '0 16px',fontSize:'14px' }">
			推荐行程
		</van-divider>
		<p class="sub-title">游览规划，为您定制专属于您的旅游攻略</p>
		<div class="guide-box" v-for="(item,index) in guideList" :key="item" @click="toDetail(index)">
			<img :src="item.imgUrl"/>
			<div class="guide-box1">
				<p class="guide-title">{{item.guideTitle}}</p>
				<p class="guide-sub-title">{{item.guideSubTitle}}</p>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		setup() {
			const guideList = [{
				guideTitle: '亲子路线',
				guideSubTitle: '带着孩子雕塑,体验不一样的童年',
				imgUrl: require('@/assets/image/guide/parent-child1.jpg'),
				detail:'洪江村是贵州省2020年评定的省级乡村旅游重点村，坐落在朝阳镇西南面。一块平整的土地被群山环抱，中间零星散落着一些并不高大的房屋，一条小溪从远处的山中径直流出穿过村庄。溪流清澈，蓝天白云，空气湿润，人们农耕细作，自然淳朴。',
				updateDate:'2024-11-11',
				addr:'贵州黔南州荔波县朝阳镇洪江村',
				browse:'159次浏览',
				spotTitle:'雕塑艺术创意',
				spotContent:'专为培养孩子艺术审美、创新思维及实践技能而设计的综合性艺术教育课程。通过深入探索雕塑艺术创意的发展历程、材料、技术、形态、空间语言以及当代雕塑的创新实践，旨在激发孩子从历史和现实生活中提取灵感，促使他们将个性化的观点和情感融入到艺术创作之中',
				spotImg:require('@/assets/image/statue.jpg')
			},
			{
				guideTitle: '情侣路线',
				guideSubTitle: '远离城市的喧嚣与烦扰',
				imgUrl: require('@/assets/image/guide/guide2.jpeg'),
				detail:'洪江村是贵州省2020年评定的省级乡村旅游重点村，坐落在朝阳镇西南面。一块平整的土地被群山环抱，中间零星散落着一些并不高大的房屋，一条小溪从远处的山中径直流出穿过村庄。溪流清澈，蓝天白云，空气湿润，人们农耕细作，自然淳朴。',
				updateDate:'2024-11-11',
				addr:'贵州黔南州荔波县朝阳镇洪江村',
				browse:'188次浏览',
				spotTitle:'有一种幸福，叫住在洪江',
				spotContent:'每个人心中都有一个美丽田园梦,那里的山水风景、草木风姿远离城市的喧嚣与烦扰让人心驰神往去乡村住上一段时间就成了我们实现田园梦的最佳生活方式,这里，被称为荔波的“后花园”这里，被称为南方的“宋庄”当文艺的唯美遇上田园的馨香孕育这座独一无二的“网红村”洪江国际艺术村',
				spotImg:require('@/assets/image/ecology3.jpeg')
			},
			{
				guideTitle: '单人之旅',
				guideSubTitle: '远离城市的喧嚣与烦扰，找个神仙村寨待着多好',
				imgUrl: require('@/assets/image/guide/guide4.jpg'),
				detail:'洪江村是贵州省2020年评定的省级乡村旅游重点村，坐落在朝阳镇西南面。一块平整的土地被群山环抱，中间零星散落着一些并不高大的房屋，一条小溪从远处的山中径直流出穿过村庄。溪流清澈，蓝天白云，空气湿润，人们农耕细作，自然淳朴。',
				updateDate:'2024-11-11',
				addr:'贵州黔南州荔波县朝阳镇洪江村',
				browse:'165次浏览',
				spotTitle:'当文艺的唯美遇上田园的馨香',
				spotContent:'洪江村是贵州荔波一个布依族聚居村落，从荔波县城沿着一条大山旁凿出的山路驱车20公里，穿过一座山腰就可到达。洪江村被群山环抱站在山入口处眺望，一片开阔而平整的土地便映入眼帘，零星散落着一些并不高大的房屋，一条小溪从远处的山中径直流出穿过村庄。这里有山水田园的农家生活夏天里最唯美的映日荷花拍抖音绝对不能少的文艺背景墙外景古朴神秘，内部文艺简洁的民居',
				spotImg:require('@/assets/image/ecology4.jpeg')
			},
			{
				guideTitle: '单人之旅',
				guideSubTitle: '一个人的时候也要精致的旅途',
				imgUrl: require('@/assets/image/guide/ych.jpg'),
				detail:'洪江村是贵州省2020年评定的省级乡村旅游重点村，坐落在朝阳镇西南面。一块平整的土地被群山环抱，中间零星散落着一些并不高大的房屋，一条小溪从远处的山中径直流出穿过村庄。溪流清澈，蓝天白云，空气湿润，人们农耕细作，自然淳朴。',
				updateDate:'2024-12-24',
				addr:'贵州黔南州荔波县朝阳镇洪江村',
				browse:'199次浏览',
				spotTitle:'“隐”在乡间里的“艺术国度',
				spotContent:'在距离“中国南方喀斯特”世界自然遗产地核心区荔波小七孔仅4公里的地方，有一个遗世独立的村庄，田园诗般的山谷、丰富个性的房屋壁画……这里是荔波县洪江村。春光正好，走进洪江村。阳光洒在房檐，墙角樱花开得尤甚。金黄色的油菜花包围了整个村庄，每户人家墙上都有不一样的艺术画，田间地头，花香萦绕在鼻尖，耳边尽是虫叫鸟鸣，沉寂的洪江村在艺术的点化下，愈发芬芳。',
				spotImg:require('@/assets/image/history2.jpeg')
			},
			{
				guideTitle: '亲子路线',
				guideSubTitle: '带着孩子共居艺术生活',
				imgUrl: require('@/assets/image/guide/guide5.jpg'),
				detail:'洪江村是贵州省2020年评定的省级乡村旅游重点村，坐落在朝阳镇西南面。一块平整的土地被群山环抱，中间零星散落着一些并不高大的房屋，一条小溪从远处的山中径直流出穿过村庄。溪流清澈，蓝天白云，空气湿润，人们农耕细作，自然淳朴。',
				updateDate:'2024-11-09',
				addr:'贵州黔南州荔波县朝阳镇洪江村',
				browse:'209次浏览',
				spotTitle:'共居艺术生活',
				spotContent:'初次来到洪江艺术村拉岜艺术家私邸，这里的一切都让我感到新奇。整个居住环境分为AB两栋，更像是一个艺术家的工作室，无论是房屋的结构还是整体氛围的营造，都让人感受到一种接近生活的艺术感。住在这里，仿佛置身于一个艺术展览馆，这种体验非常奇妙',
				spotImg:require('@/assets/image/painting.jpg')
			}]
			return{
				guideList
			}
		},
		methods:{
			toDetail(index){
				// console.log(this.guideList[index])
				this.$router.push({ path: '/detail', query: { data: encodeURIComponent(JSON.stringify(this.guideList[index] ))}});
			}
		}
		
	}
</script>

<style scoped>
	.sub-title {
		font-size: 24px;
		text-align: center;
		color: #717171;
	}

	.guide-box {
		width: 96%;
		height: 300px;
		border-radius: 15px;
		margin-left: 2%;
		margin-top: 20px;
		position: relative;
	}

	.guide-box1 {
		width: 100%;
		height: 100px;
		background: rgba(0, 0, 0, 0.4);
		position: absolute;
		z-index: 9999;
		bottom: 0;
		border-bottom-left-radius: 15px;
		border-bottom-right-radius: 15px;
	}

	.guide-box img {
		width: 100%;
		height: 100%;
		border-radius: 15px;
		z-index: -1;
	}

	.guide-title {
		position: absolute;
		color: #fff;
		font-size: 28px;
		bottom: 60px;
		left: 20px;
		font-weight: bold;
	}

	.guide-sub-title {
		position: absolute;
		font-size: 24px;
		color: #fff;
		bottom: 20px;
		left: 20px;
	}
	/deep/.van-nav-bar__content{
		height: 80px;
	}
	/deep/.van-nav-bar__title{
		font-size: 30px;
		line-height: 50px;
	}
	/deep/.van-nav-bar__text{
		font-size: 30px;
	}
</style>
